module.exports = __webpack_public_path__ + "static/media/healthcare_doc_p1_2.91143108.png";